import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './index.scss';
import '../../css/global.css';
import '../../css/normalize.css';
import api from '../../api.js';
import Cabecalho from '../../components/Cabecalho';
import Rodape from '../../components/Rodape';

export default function Manutencao() {
    const [motivo, setMotivo] = useState('');

    useEffect(() => {
        const carregarStatus = async () => {
            try {
                const response = await api.get('/api/site-status');
                if (response.data?.status === 'manutencao') {
                    setMotivo(response.data?.motivo || 'Estamos realizando melhorias no sistema.');
                }
            } catch (error) {
                setMotivo('Estamos realizando melhorias no sistema.');
            }
        };
        carregarStatus();
    }, []);

    return (
        <section className='container-Principal-Login manutencao'>
            <Cabecalho />
            <main>
                <section className="conteudoMain">
                    <ul className="circulos">
                        <li></li>
                        <li></li>
                        <li></li>
                        <li></li>
                        <li></li>
                        <li></li>
                        <li></li>
                        <li></li>
                        <li></li>
                        <li></li>
                    </ul>

                    <div className="areaLogin areaManutencao">
                        <h1>Manutenção</h1>
                        <h2>Voltamos em breve</h2>

                        <div className='manutencao-info'>
                            <div className='icon'>
                                <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <circle cx="40" cy="40" r="38" fill="#FFF3E0" />
                                    <path d="M40 18C28.4 18 19 27.4 19 39C19 50.6 28.4 60 40 60C51.6 60 61 50.6 61 39C61 27.4 51.6 18 40 18ZM40 56C30.1 56 22 47.9 22 39C22 30.1 30.1 22 40 22C49.9 22 58 30.1 58 39C58 47.9 49.9 56 40 56Z" fill="#F57C00" />
                                    <path d="M38 28H42V44H38V28ZM38 48H42V52H38V48Z" fill="#F57C00" />
                                </svg>
                            </div>
                            <p>{motivo}</p>
                            <span className='hint'>Apenas administradores podem acessar durante a manutenção.</span>
                        </div>
                    </div>
                </section>
            </main>
            <Rodape />
        </section>
    );
}
